import React, { useRef, useState } from "react";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import './CityAutoComplete.css';

const libraries = ["places"];

const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

async function fetchLatLng(cityName) {
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(cityName)}&key=${apiKey}`;
  const resp = await fetch(url);
  const data = await resp.json();
  if (data.status === "OK" && data.results.length > 0) {
    const loc = data.results[0].geometry.location;
    return { lat: loc.lat, lng: loc.lng };
  }
  return { lat: null, lng: null };
}

export default function CityAutocomplete({ selectedCountries, selectedCities, setSelectedCities }) {
  const autocompleteRef = useRef(null);
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState("");

  // Use the first selected country for restriction (Google only supports one at a time)
  const countryCode = selectedCountries.length > 0 ? selectedCountries[0].value : "";

  const handlePlaceChanged = async () => {
    const place = autocompleteRef.current.getPlace();
    if (
      place &&
      place.name &&
      !selectedCities.some(c => c.place_id === place.place_id)
    ) {
      // Fetch lat/lng using Google Geocoding API
      const { lat, lng } = await fetchLatLng(place.name);
      setSelectedCities([
        ...selectedCities,
        {
          name: place.name,
          place_id: place.place_id,
          lat,
          lng
        }
      ]);
      setInputValue("");
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const handleRemoveCity = (place_id) => {
    setSelectedCities(selectedCities.filter(c => c.place_id !== place_id));
  };

  return (
      <div className="city-autocomplete-input-wrapper">
        {selectedCities.map(city => (
          <span className="city-chip" key={city.place_id}>
            {city.name}
            <button
              type="button"
              className="city-chip-remove"
              onClick={() => handleRemoveCity(city.place_id)}
              aria-label="Remove city"
            >×</button>
          </span>
        ))}
        <Autocomplete
          onLoad={ref => (autocompleteRef.current = ref)}
          onPlaceChanged={handlePlaceChanged}
          options={{
            types: ["(cities)"],
            componentRestrictions: countryCode ? { country: countryCode } : undefined,
          }}
        >
          <input
            type="text"
            ref={inputRef}
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
            placeholder="Type a city or region"
            disabled={!selectedCountries.length}
            className="city-input"
            onKeyDown={e => {
              // Prevent form submit on Enter if Google dropdown is open
              if (e.key === "Enter") {
                e.stopPropagation();
                // Prevent form submit, let Google handle selection
                if (document.querySelector('.pac-container') && document.querySelector('.pac-container').style.display !== 'none') {
                  e.preventDefault();
                }
              }
            }}
          />
        </Autocomplete>
      </div>
   
  );
}